import settings from '../virtuoso/settings';
import ApiUtils from '../virtuoso/ApiUtils';
import LiferayApiUtils from '../liferay/ApiUtils';
import LiferaySettings from '../liferay/settings';
import { PredicatSubjectRequest, 
    NewIndividualRequest, DeleteSubjectRequest, DeleteObjectRequest, 
    RdfsLabelRequest, DcTermsTitleRequest,
    DCTermsDescriptionRequest, AddPropertyInAssetRequest,
    RemovePropertyInAssetRequest, UpdateLiteralPropertyRequest, UpdateObjectPropertyRequest,
    NamedIndividualsRequest, DeleteLiteralValueInPropertyRequest, DeleteLinkValueInPropertyRequest,
    InsertTripleLiteralRequest,
    //Получение списка индивидуалов справочников объектных свойств
    VocabsRequest, VocabsCountRequest, VocabsIRIRequest} from '../virtuoso/request';
import { makeWhereFilter, makeWhereFilterAdv } from '../virtuoso/filter';
import { getCountValue2 } from '../virtuoso/helper';
import { dispatch } from 'd3';


/** Проверяет, что есть назначенный условия */
const isConditionPresent = (conditions, rfilter) => {
    return (Array.isArray(conditions) && conditions.length>0) || (Array.isArray(rfilter) && rfilter.length>0);
}
/** Формирует запрос с учётом наличия условий. Если условяи есть, то делается cloneOriginal() 
 * и добавляются условия! */
const makeRequest = (pattern, conditions, rfilter) => {
    if (!isConditionPresent(conditions, rfilter))
        return pattern;
    const request = pattern.cloneOriginal();
    makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
    return request;
}

//Загрузка описание справочников ADMS каталога
export const VocabsRepository = {
    //Значение обязательного фильтра
    RFILTER: [],
    EMPTY: () => ({
        type: "VocabsRepository.EMPTY",
    }),
    SET_RFILTER: rfilter => {
        AdmsRepository.RFILTER = rfilter;
        return ({
            type: "VocabsRepository.SET_RFILTER", 
            rfilter
        })
    },
    LOAD_STARTED: () => ({
        type: "VocabsRepository.LOAD_STARTED",
    }),
    LOAD_ERROR: (error) => ({
        type: "VocabsRepository.LOAD_ERROR",
        error
    }),
    LOAD_DESCRIPTION: (IRI, description) => ({
        type: "VocabsRepository.LOAD_DESCRIPTION",
        IRI, description
    }),
    LOAD_VOCABS: (offset, limit, count, head, distinct, ordered, items) => ({
        type: "VocabsRepository.LOAD_VOCABS",
        offset, limit, count, head, distinct, ordered, items
    }),
    LOAD_NEXTVOCABS: (offset, limit, head, distinct, ordered, items) => ({
        type: "VocabsRepository.LOAD_NEXTVOCABS",
        offset, limit, head, distinct, ordered, items
    }),
    STATISTICS: (IRI, statistic) => ({
        type: "VocabsRepository.STATISTICS", 
        IRI, statistic
    }),
    ADD_VOCABS: (iri, type, label, lang) =>({
        type: "VocabsRepository.ADD_VOCABS",
        iri, label, lang
    }),
    REMOVE_VOCABS: (iri) => ({
        type: "VocabsRepository.REMOVE_VOCABS",
        iri,
    }),
    CONDITIONS: conditions => ({
        type: "VocabsRepository.CONDITIONS",
        conditions,
    }),

    /** Загрузить информацию об индивидуалах из спровчников объектных свойств в список. 
     * conditions - условия отбора,  rfilter - обязательные условия отбора. 
     * При загрузке дополнительно загружается количество индивидуалов */
    loadVocabs: (conditions=[], rdfTypes=[], lang, rfilter=VocabsRepository.RFILTER) => dispatch => {
        dispatch(VocabsRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(VocabsRequest, conditions, rfilter);
        request.request.offset = 0;
        request.request.limit = settings.defaultLimit;
        const counter = makeRequest(VocabsCountRequest, conditions, rfilter);
        if (Array.isArray(rdfTypes) && rdfTypes.length>0){
            request.setTypes(rdfTypes);
            counter.setTypes(rdfTypes);
        };
        request.setLang(lang);
        //console.log("VocabsActions.js loadVocabs", request);
        return Promise.all([
                ApiUtils.query(request, {}, options),
                ApiUtils.query(counter, {}, options),
            ]).then ((response) =>{
                const {head, results} = response[0];
                const {distinct, ordered, bindings} = results;
                const count = getCountValue2(response[1].results.bindings, -1);
                dispatch(VocabsRepository.LOAD_VOCABS(0, request.request.limit, count, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(VocabsRepository.LOAD_ERROR(`Ошибка при выполнении запроса в loadVocabs ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить следующую порцию информации об индивидуалах */
    loadNextVocabs: (offset, conditions=[], rdfTypes=[], lang, rfilter=VocabsRepository.RFILTER) => dispatch => {
        dispatch(VocabsRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(VocabsRequest, conditions, rfilter);
        if (Array.isArray(rdfTypes) && rdfTypes.length>0){
            request.setTypes(rdfTypes);
        };
        request.setLang(lang);
        request.request.offset = offset;
        request.request.limit = settings.defaultLimit;
        //console.log("VocabsActions.js loadNextVocabs", request);
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(VocabsRepository.LOAD_NEXTVOCABS(offset, request.request.limit, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(VocabsRepository.LOAD_ERROR(`Ошибка при выполнении запроса в loadNextVocabs ${e}.`));
                return Promise.reject(e);
            });
    },


    // Load all vocabs IRIs for export.
    loadIRIVocabs: (conditions=[], rdfTypes=[], lang, rfilter=VocabsRepository.RFILTER) => dispatch => {
        const options = {...settings.options};
        const request = makeRequest(VocabsIRIRequest.cloneOriginal(), conditions, rfilter);
        if (Array.isArray(rdfTypes) && rdfTypes.length>0){
            request.setTypes(rdfTypes);
        };
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const bindings = response?.results?.bindings ?? [];
                const IRIs = [...new Set(
                    bindings
                        .map(item => item?.IRI?.value)
                        .filter(Boolean)
                )];
                return Promise.resolve(IRIs);
            })
            .catch(e => { 
                dispatch(VocabsRepository.LOAD_ERROR(`loadIRIVocabs error ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Добавление нового элемента. Для добавления используется прокси сервис в Liferay */
    addElement: (iri, type, label, lang) => dispatch => {
        NewIndividualRequest.setValues(iri, type, label, lang);
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
          'default_graph_uri': NewIndividualRequest.graph,
          'query': NewIndividualRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)
          .then ((response) =>{
                dispatch(VocabsRepository.ADD_VOCABS(iri, label, lang));
                return Promise.resolve({iri, type, label, lang, response});
          })
          .catch(e => { 
                dispatch(VocabsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
          });
    },

    /** Добавление нового элемента. Для добавления используется прокси сервис в Liferay */
    deleteElement: (iri) => dispatch => {
        DeleteSubjectRequest.setIRI(iri);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteSubjectRequest.graph,
            'query': DeleteSubjectRequest.sparql,
          }
        DeleteObjectRequest.setIRI(iri);
        const formData2 = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteObjectRequest.graph,
            'query': DeleteObjectRequest.sparql,
          }
          //console.log("SkosActions.js deleteElement", formData, options);
        return Promise.all([
                LiferayApiUtils.postToLifeRay721(formData, options),
                LiferayApiUtils.postToLifeRay721(formData2, options)
            ]).then ((response) =>{
                dispatch(VocabsRepository.REMOVE_VOCABS(iri));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(VocabsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию об описаниии актива. Значение для предиката http://purl.org/dc/terms/description  */
    loadDescription: (iri) => dispatch => {
        const options = {...settings.options};
        DCTermsDescriptionRequest.setURI(iri);
        return ApiUtils.query(DCTermsDescriptionRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(VocabsRepository.LOAD_DESCRIPTION(iri, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(VocabsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },    
};

export const VocabsIndividual = {
    EMPTY: () => ({
        type: "VocabsIndividual.EMPTY",
    }),
    LOAD_STARTED: () => ({
        type: "VocabsIndividual.LOAD_STARTED",
    }),
    LOAD_ERROR: (error) => ({
        type: "VocabsIndividual.LOAD_ERROR",
        error
    }),
    LOAD_INDIVIDUAL: (iri, head, values) => ({
        type: "VocabsIndividual.LOAD_INDIVIDUAL",
        iri, values, head,
        types: (values && Array.isArray(values))
            ?[...new Set(
                values.filter(item => item.predicat.value == "http://www.w3.org/1999/02/22-rdf-syntax-ns#type")
                      .map(item => item.object.value))
             ]
            :[], 
        predicates : (values && Array.isArray(values))
            ?[...new Set(values.map(item => item.predicat.value))]
            :[], 
        languages: (values && Array.isArray(values))?[...new Set(values.map(item => item.object["xml:lang"]))]:[], 
    }),
    LOAD_LABELBYIRI: (iri, head, values) => ({
        type: "VocabsIndividual.LOAD_LABELBYIRI",
        iri, values, head,
    }),

    LOAD_DETAIL: (triplet, head, values, state) => ({
        type: "VocabsIndividual.LOAD_DETAIL",
        triplet, head, values, state,
    }),

    ADD_NODES: (values, contents) => ({
        type: "VocabsIndividual.ADD_NODES",
        values, contents,
    }),


    /** Загрузить информацию об индивидуалах по IRI */
    loadIndividual: (iri) => dispatch => {
        dispatch(VocabsIndividual.LOAD_STARTED());
        const options = {...settings.options};
        PredicatSubjectRequest.setIRI(iri);
        //Вызов sparql_select (вместо sparql_select_json) для получения полного ID анонимных узлов 
        //nodeID://b354043 вместо b0 и т.п.
        return ApiUtils.querySelect(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(VocabsIndividual.LOAD_INDIVIDUAL(iri, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(VocabsIndividual.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },


    loadSelected: (iri) => dispatch => {
        return dispatch(VocabsIndividual.loadIndividual(iri));
    },

    // Загрузить информацию о метках 
    loadLabelByIRI: (IRI) => dispatch => {
        const options = {...settings.options};
        RdfsLabelRequest.setURI(IRI);
        return ApiUtils.query(RdfsLabelRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(VocabsIndividual.LOAD_LABELBYIRI(IRI, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(VocabsIndividual.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    // Загрузить информацию о заголовках
    loadTitleByIRI: (IRI) => dispatch => {
        const options = {...settings.options};
        DcTermsTitleRequest.setURI(IRI);
        return ApiUtils.query(DcTermsTitleRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(VocabsIndividual.LOAD_LABELBYIRI(IRI, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(VocabsIndividual.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получение детальной информации о триплете */
    onDetailElement: (triplet) => dispatch => {
        const options = {...settings.options};
        PredicatSubjectRequest.setIRI(triplet.object.value);
        return ApiUtils.query(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(VocabsIndividual.LOAD_DETAIL(triplet, head, bindings, "loaded"));
                return Promise.resolve({triplet, head, distinct, ordered, bindings});
            })
            .catch(e => { 
                dispatch(VocabsIndividual.LOAD_DETAIL(triplet, [], [], "error"));
                return Promise.reject(e);
            });
    },


    addProperty: (IRI, predicat, lang) => dispatch => {
        AddPropertyInAssetRequest.setValues(IRI, predicat);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': AddPropertyInAssetRequest.graph,
            'query': AddPropertyInAssetRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({IRI, response});
            })
            .catch(e => { 
                dispatch(VocabsIndividual.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    insertTriple: (subject, predicat, value, lang=undefined) => dispatch => {
        InsertTripleLiteralRequest.setValues(subject, predicat, value, lang);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri':InsertTripleLiteralRequest.graph,
            'query': InsertTripleLiteralRequest.sparql,
          }
        //console.log("AdmsActions.js insertTriple", subject, predicat, value, lang, InsertTripleRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({subject, predicat, value, lang});
            })
            .catch(e => { 
                dispatch(VocabsIndividual.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    removeProperty: (IRI, predicat) => dispatch => {
        RemovePropertyInAssetRequest.setValues(IRI, predicat);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': RemovePropertyInAssetRequest.graph,
            'query': RemovePropertyInAssetRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(VocabsIndividual.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    updateLiteralProperty: (IRI, predicat, oldValue, newValue, lang) => dispatch => {
        UpdateLiteralPropertyRequest.setValues(IRI, predicat, oldValue, newValue, lang);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': UpdateLiteralPropertyRequest.graph,
            'query': UpdateLiteralPropertyRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(VocabsIndividual.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    updateObjectProperty: (IRI, predicat, oldValue, newValue) => dispatch => {
        UpdateObjectPropertyRequest.setValues(IRI, predicat, oldValue, newValue);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': UpdateObjectPropertyRequest.graph,
            'query': UpdateObjectPropertyRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(VocabsIndividual.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
 
    /** Загрузить информацию об индивидуалах. rdfType - IRI типf */
    loadNamedIndividuals: (rdfType, graph) => {
        const options = {...settings.options};
        NamedIndividualsRequest.setType(rdfType);
        return ApiUtils.query(NamedIndividualsRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({rdfType, head, distinct, ordered, bindings});
            })
            .catch(e => { 
                return Promise.reject(e);
            });
    }, 

    deleteValueInProperty: (IRI, predicat, value) => dispatch => {
        const request = (value && value.startsWith("http")) ? DeleteLinkValueInPropertyRequest:DeleteLiteralValueInPropertyRequest;
        request.setValues(IRI, predicat, value);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': request.graph,
            'query': request.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

}
